export const business = {
  name: 'Vincent Monti',
  activity: 'Jardinier paysagiste',
  street: '2 bis rue de la Justice',
  postalCode: '91750',
  city: 'Champcueil',
  siren: '941 519 282',
  siret: '941 519 282 00011',
};

export const navigation = [
  { label: 'Accueil', to: '/' },
  { label: 'Prestations', to: '/prestations' },
  { label: 'Réalisations', to: '/realisations' },
  { label: 'À propos', to: '/a-propos' },
  { label: 'Contact', to: '/contact' },
];

export const services = [
  {
    title: 'Entretien de jardin',
    description:
      'Passages ponctuels ou réguliers : désherbage, nettoyage des massifs, ramassage des feuilles. Votre jardin reste propre toute l’année.',
  },
  {
    title: 'Tonte et soin de la pelouse',
    description:
      'Tonte, bordures, scarification et regarnissage pour un gazon dense et homogène.',
  },
  {
    title: 'Taille de haies et d’arbustes',
    description:
      'Taille de formation ou d’entretien, au bon moment de la saison, pour des haies nettes et des arbustes en bonne santé.',
  },
  {
    title: 'Création et aménagement',
    description:
      'Massifs, allées, bordures, plantations : un aménagement pensé pour votre terrain, votre exposition et votre temps disponible.',
  },
  {
    title: 'Débroussaillage et évacuation',
    description:
      'Remise en état de terrains délaissés et évacuation des déchets verts après chaque intervention.',
  },
];

export const steps = [
  {
    title: 'Vous me contactez',
    description: 'Décrivez votre jardin et vos besoins via le formulaire de demande de devis.',
  },
  {
    title: 'Visite sur place',
    description: 'Je passe voir le terrain pour comprendre l’existant et vos attentes.',
  },
  {
    title: 'Devis gratuit et détaillé',
    description: 'Vous recevez un devis clair, poste par poste, sans engagement.',
  },
  {
    title: 'Intervention',
    description: 'Le travail est réalisé à la date convenue, et le chantier laissé propre.',
  },
];

export const serviceArea = [
  'Champcueil',
  'Mennecy',
  'Ballancourt-sur-Essonne',
  'Chevannes',
  'Auvernaux',
  'Nainville-les-Roches',
  'Soisy-sur-École',
  'Fontenay-le-Vicomte',
  'Ormoy',
  'Le Coudray-Montceaux',
  'Corbeil-Essonnes',
];

export const requestTypes = [
  'Entretien régulier',
  'Intervention ponctuelle',
  'Taille de haies',
  'Création / aménagement',
  'Autre',
];

export const images = {
  hero: 'https://cdn.magicpatterns.com/patterns/generated-images/50fcb47e-9924-408c-9e69-fa0f227da828.jpg',
  hedge: 'https://cdn.magicpatterns.com/patterns/generated-images/1ccbfe49-1d62-4b51-99b1-d342d7c5d256.jpg',
  design: 'https://cdn.magicpatterns.com/patterns/generated-images/125ccfa8-d69e-45a5-9811-9e045aed53c5.jpg',
  gardener: 'https://cdn.magicpatterns.com/patterns/generated-images/9a7f61e4-a7b8-4a34-9f99-31e999deb6ea.jpg',
  lawn: 'https://cdn.magicpatterns.com/patterns/generated-images/c3c4d523-5cb2-484c-8cee-bf61aa0269ed.jpg',
  autumn: 'https://cdn.magicpatterns.com/patterns/generated-images/9d9adaa5-03db-4df7-8c7e-24c8e8be65d1.jpg',
  shrubs: 'https://cdn.magicpatterns.com/patterns/generated-images/2abda9d5-dd5b-4fbb-9f46-9ad7a2c7266e.jpg',
};

export const commitments = [
  {
    title: 'Un seul interlocuteur',
    description: 'C’est moi qui vous réponds, qui établis le devis et qui interviens dans votre jardin.',
  },
  {
    title: 'Des devis clairs',
    description: 'Chaque poste est détaillé. Pas de surprise sur la facture finale.',
  },
  {
    title: 'Un chantier laissé propre',
    description: 'Déchets verts ramassés et évacués, allées et terrasses balayées avant de partir.',
  },
  {
    title: 'Le respect du vivant',
    description: 'Tailles aux bonnes périodes, attention aux nids et aux haies refuges, désherbage sans produits chimiques.',
  },
];

export const seasons = [
  {
    id: 'printemps',
    name: 'Printemps',
    months: 'Mars – mai',
    intro: 'Le jardin se réveille : c’est le moment de préparer la saison.',
    tasks: [
      'Première tonte et scarification de la pelouse',
      'Nettoyage et paillage des massifs',
      'Plantation de vivaces et d’arbustes',
      'Taille des arbustes à floraison estivale',
    ],
  },
  {
    id: 'ete',
    name: 'Été',
    months: 'Juin – août',
    intro: 'La pousse est au maximum : un entretien régulier évite de se laisser déborder.',
    tasks: [
      'Tontes régulières, hauteur adaptée à la chaleur',
      'Taille d’entretien des haies (hors période de nidification)',
      'Désherbage des allées et des massifs',
      'Conseils d’arrosage et de paillage',
    ],
  },
  {
    id: 'automne',
    name: 'Automne',
    months: 'Septembre – novembre',
    intro: 'La meilleure saison pour planter et préparer le jardin à l’hiver.',
    tasks: [
      'Ramassage des feuilles et évacuation',
      'Taille des haies avant l’hiver',
      'Plantation d’arbres, de haies et de bulbes',
      'Regarnissage de la pelouse',
    ],
  },
  {
    id: 'hiver',
    name: 'Hiver',
    months: 'Décembre – février',
    intro: 'Le jardin se repose, mais c’est le temps des gros travaux de structure.',
    tasks: [
      'Taille des arbres fruitiers et des rosiers',
      'Débroussaillage et remise en état de terrains',
      'Préparation des projets d’aménagement',
      'Protection des plantes fragiles',
    ],
  },
];

export const plans = [
  {
    name: 'Intervention ponctuelle',
    tagline: 'Pour un besoin précis, une fois.',
    forWho: 'Remise en état après une absence, taille de haie annuelle, nettoyage d’automne, préparation d’un événement.',
    points: ['Devis sur mesure après visite', 'Une date fixée ensemble', 'Évacuation des déchets verts incluse'],
    featured: false,
  },
  {
    name: 'Entretien régulier',
    tagline: 'Pour ne plus avoir à y penser.',
    forWho: 'Passages planifiés toute l’année selon la saison et la taille de votre jardin : hebdomadaires, mensuels ou à la demande.',
    points: [
      'Calendrier établi en début d’année',
      'Tonte, taille, désherbage au bon moment',
      'Un jardin suivi par la même personne',
      'Tarif fixé à l’avance',
    ],
    featured: true,
  },
];

export const gallery = [
  { src: images.lawn, alt: 'Pelouse fraîchement tondue avec bordures nettes', caption: 'Tonte et bordures' },
  { src: images.shrubs, alt: 'Haie de charmes et arbustes taillés en boule', caption: 'Taille de haies et d’arbustes' },
  { src: images.autumn, alt: 'Tas de feuilles ratissées et brouette dans un jardin en automne', caption: 'Nettoyage d’automne' },
];

export const faqs = [
  {
    question: 'Le devis est-il payant ?',
    answer: 'Non. La visite et le devis sont gratuits et sans engagement.',
  },
  {
    question: 'Que deviennent les déchets verts ?',
    answer: 'Ils sont ramassés et évacués à la fin de chaque intervention. Vous n’avez rien à gérer.',
  },
  {
    question: 'Dois-je être présent pendant l’intervention ?',
    answer:
      'Ce n’est pas obligatoire. Il suffit que le jardin soit accessible. Beaucoup de clients préfèrent être absents lors des passages réguliers.',
  },
  {
    question: 'Le matériel est-il fourni ?',
    answer: 'Oui, j’interviens avec mon propre matériel professionnel : tondeuse, taille-haie, souffleur, outillage.',
  },
  {
    question: 'Intervenez-vous pour les petits jardins ?',
    answer: 'Oui, quelle que soit la surface. Un petit jardin mérite autant d’attention qu’un grand terrain.',
  },
  {
    question: 'Quels sont les délais pour une première intervention ?',
    answer:
      'Ils varient selon la saison. Le printemps et l’automne sont les périodes les plus chargées : mieux vaut anticiper sa demande.',
  },
];
